import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module ui/editableui/inline/inlineeditableuiview
 */
import EditableUIView from '../editableuiview.js';
/**
 * The inline editable UI class implementing an inline {@link module:ui/editableui/editableuiview~EditableUIView}.
 */
var InlineEditableUIView = /*#__PURE__*/function (_EditableUIView) {
  _inherits(InlineEditableUIView, _EditableUIView);
  var _super = _createSuper(InlineEditableUIView);
  /**
   * Creates an instance of the InlineEditableUIView class.
   *
   * @param locale The locale instance.
   * @param editingView The editing view instance the editable is related to.
   * @param editableElement The editable element. If not specified, the
   * {@link module:ui/editableui/editableuiview~EditableUIView}
   * will create it. Otherwise, the existing element will be used.
   * @param options Additional configuration of the view.
   * @param options.label A function that gets called with the instance of this view as an argument
   * and should return a string that represents the label of the editable for assistive technologies. If not provided,
   * a default label generator is used.
   */
  function InlineEditableUIView(locale, editingView, editableElement) {
    var _this;
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    _classCallCheck(this, InlineEditableUIView);
    _this = _super.call(this, locale, editingView, editableElement);
    var t = locale.t;
    _this.extendTemplate({
      attributes: {
        role: 'textbox',
        class: 'ck-editor__editable_inline'
      }
    });
    _this._generateLabel = options.label || function () {
      return t('Editor editing area: %0', _this.name);
    };
    return _this;
  }
  /**
   * @inheritDoc
   */
  _createClass(InlineEditableUIView, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      _get(_getPrototypeOf(InlineEditableUIView.prototype), "render", this).call(this);
      var editingView = this._editingView;
      editingView.change(function (writer) {
        var viewRoot = editingView.document.getRoot(_this2.name);
        writer.setAttribute('aria-label', _this2._generateLabel(_this2), viewRoot);
      });
    }
  }]);
  return InlineEditableUIView;
}(EditableUIView);
export { InlineEditableUIView as default };